import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { OrderBumpPageParamsValidationSchema } from './params';

const reorderOrderBumpsBodyShape = {
  productIds: z.array(ObjectIdStringValidationSchema).meta({
    description:
      'Every order bump product ID on the page, each exactly once, in the order to show them.',
  }),
};

export const ReorderOrderBumpsRequestValidationSchema = z
  .object(reorderOrderBumpsBodyShape)
  .strict()
  .meta({ id: 'ReorderOrderBumpsRequest' });

export const ReorderOrderBumpsInputValidationSchema = OrderBumpPageParamsValidationSchema.extend(
  reorderOrderBumpsBodyShape,
);

export type ReorderOrderBumpsInput = z.infer<typeof ReorderOrderBumpsInputValidationSchema>;
